import { useMemo } from "react"
import { useJobtrackBonus, useGetSavedBonusPercentages } from "../scripts/queries/useBonusQueries";
import { usePlantFilters, searchRows, usePlantTable, sortedRows, exportPlantTables, getWeekThresholds } from "./usePlantTable";

const EMPTY_ARRAY = [];
const MET = 'SI SE CUMPLE';
const NOT_MET = 'NO SE CUMPLE';

const BONO_COLUMNS = [
    {accessorKey: 'nomina', header: 'Código', type: 'text', width: 90},
    {accessorKey: 'codigoMetrics', header: 'Código Metrics', type: 'text', width: 130},
    {accessorKey: 'operador', header: 'Nombre completo', type: 'text', width: 300},
    {accessorKey: 'maquinaNomina', header: 'Máquina', note: 'Máquina del listado de nómina actual, no la que tenía ese día', type: 'text', width: 150},
    {accessorKey: 'maquina', header: 'Rol', type: 'text', width: 150},
    {accessorKey: 'status', header: 'Status rol', type: 'text', width: 130},
    {accessorKey: 'statusNomina', header: 'Status', type: 'text', width: 130},
    {accessorKey: 'maquinaReportada', header: 'Máquina reportada', type: 'text', width: 170},
    {accessorKey: 'arregloRealDia', header: 'Arreglo real', type: 'dec'},
    {accessorKey: 'hrsProdRealDia', header: 'Hrs prod real', type: 'dec'},
    {accessorKey: 'hrsImprodRealDia', header: 'Hrs improd real', type: 'dec'},
    {accessorKey: 'horasSinOpDia', header: 'Horas sin OP', type: 'dec'},
    {accessorKey: 'captura', header: 'Diferencia en horas %', type: 'pct', width: 170},
    {accessorKey: 'hrsTotalBruto', header: 'Total horas laboradas reloj checador', type: 'dec', width: 220},
    {accessorKey: 'eficiencia', header: 'Eficiencia trabajador', type: 'pct', width: 170},
    {accessorKey: 'rate', header: 'Rate para bono', type: 'pct'},
    {accessorKey: 'criterioCaptura', header: 'Criterio 1 captura completa de horas', type: 'text', width: 230},
    {accessorKey: 'criterioEficiencia', header: 'Criterio 2 eficiencia', type: 'text', width: 180},
    {accessorKey: 'bono', header: 'Bono', type: 'pct'},
];

//The detail of the daily bonus of every employee.
export const useBonoDayNormalizer = (active = true) => {
    const filters = usePlantFilters('BONO_DAY_FILTERS');
    const {fecha, search, sorting, setSorting} = filters;

    const {data: bonus, refetch: fetchData, isFetching, isLoading: loading} = useJobtrackBonus(fecha, active);
    const {data: percentages = EMPTY_ARRAY} = useGetSavedBonusPercentages();
    const data = bonus ?? EMPTY_ARRAY;

    //Blank without clock hours or with a payroll machine N/A; the efficiency fails without a rate for the reported machine
    const processedData = useMemo(() => {
        const {rates, limits} = getWeekThresholds(percentages, fecha);

        return data.map(person => {
            const rate = rates[person.maquinaReportada] != null ? rates[person.maquinaReportada] / 100 : null;
            const blank = person.hrsTotalBruto === 0 || person.maquinaNomina === 'N/A';
            const capturaOk = limits != null && person.captura >= Number(limits.capturaMin) / 100 && person.captura <= Number(limits.capturaMax) / 100;

            const criterioCaptura = blank || !person.maquinaReportada ? '' : capturaOk ? MET : NOT_MET;
            const criterioEficiencia = blank ? '' : rate != null && person.eficiencia >= rate ? MET : NOT_MET;
            return {
                ...person,
                codigoMetrics: person.nomina ? String(Number(person.nomina)) : '',
                rate, criterioCaptura, criterioEficiencia,
                bono: (criterioCaptura === MET ? 0.5 : 0) + (criterioEficiencia === MET ? 0.5 : 0),
            };
        });
    }, [data, percentages, fecha]);

    const filteredData = useMemo(() => searchRows(processedData, search, ['nomina', 'operador', 'maquina', 'maquinaReportada']), [processedData, search]);
    const {columns, table} = usePlantTable(BONO_COLUMNS, filteredData, sorting, setSorting);

    const exportCSV = () => exportPlantTables(`Reporte_Bono_Dia_${fecha}.xlsx`, [{columns, rows: sortedRows(table)}]);

    return {...filters, table, loading, isFetching, fetchData, exportCSV};
}